import React from "react";

const d = `
M2.053 31.643l14.601-14.8a1.2 1.2 0 0 0 0-1.686L2.053.357A1.198 1.198 0 0 0 .356.347a1.201 1.201 0 0 0-.01 1.696L14.113 16 .345 29.957A1.201 1.201 0 0 0 1.2 32c.31 0 .619-.119.854-.357z
`;

export default props => {
  const style = {
    transform: props.reverse ? "rotate(180deg)" : undefined,
  };
  return (
    <svg
      width="50"
      height="50"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g transform="translate(17,8)">
        <path d={d} />
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/Home/img/arrow-right.js